export const KNOWLEDGE_SOURCES = ['public', 'engineering', 'commercial'] as const;

export type KnowledgeSource = (typeof KNOWLEDGE_SOURCES)[number];

export const KNOWLEDGE_SOURCE_LABEL_KEYS: Record<KnowledgeSource, string> = {
  public: 'knowledgeSources.public',
  engineering: 'knowledgeSources.engineering',
  commercial: 'knowledgeSources.commercial',
};

export function normalizeKnowledgeSources(value: unknown): KnowledgeSource[] {
  const received = Array.isArray(value) ? value : [];
  const valid = received.filter(
    (source): source is KnowledgeSource =>
      typeof source === 'string' && KNOWLEDGE_SOURCES.includes(source as KnowledgeSource),
  );
  return ['public', ...valid.filter((source, index) => source !== 'public' && valid.indexOf(source) === index)];
}

export function filterAuthorizedKnowledgeSources(
  selected: readonly KnowledgeSource[],
  available: readonly KnowledgeSource[],
): KnowledgeSource[] {
  return selected.filter((source, index) => available.includes(source) && selected.indexOf(source) === index);
}
